import Cookies from "js-cookie"

const signinedToken = "appToken"

let currentUser

export const request = (path, options) => {
  return fetch(path, options).then(res => (res ? res.json() : null))
}

export const requestGapi = (path, options = {}) => {
  const token = Cookies.get(signinedToken)
  const requestOptions = {
    ...options,
    headers: {
      ...options.headers,
      ...(!(options.body instanceof FormData)
        ? {
            "Content-Type": "application/vnd.api+json",
          }
        : {}),
      ...(token
        ? {
            Authorization: `Token token=${token}`,
          }
        : {}),
    },
  }
  return request(`https://www.gcores.com/gapi/v1/${path}`, requestOptions)
}

export const requestCurrentUser = () => {
  if (currentUser !== undefined) {
    return Promise.resolve(currentUser)
  } else {
    const userId = Cookies.get("userID")
    if (!userId) {
      return Promise.resolve(null)
    }
    return requestGapi(`/users/${userId}`).then(res => {
      return res?.data
    })
  }
}

export const requestGserver = (path, options) => {
  return request(`https://www.gcores.com/${path}`, options)
}
